// Maakt animatie-instanties aan op basis van het data-animate-type van
// een element, met terugval op het geconfigureerde default type.
class AnimationFactory {
	constructor(config) {
		this.config = config;
	}

	create($scope) {
		let type = $scope.data('animate-type') ?? this.config.defaultType;
		let AnimationClass = this.config.animationTypes[type];

		if (!AnimationClass) {
			console.warn(`Animate: onbekend animatietype "${type}", terugvallen op "${this.config.defaultType}"`, $scope[0]);
			AnimationClass = this.config.animationTypes[this.config.defaultType];
		}

		if (!AnimationClass) {
			console.error(`Animate: standaard animatietype "${this.config.defaultType}" is niet geregistreerd`);
			return null;
		}

		let animation = new AnimationClass($scope, this.config);
		animation.init();

		return animation;
	}
}

export default AnimationFactory;
